import { addOrUpdateCartItem } from '@/clients/storefront/cartService';
import Button, {
  type ButtonProps,
  ButtonSize,
} from '@/components/BaseLibrary/Button/Button';
import useSunrunShopStore from '@/data-store/hooks/useSunrunShopStore';

function BuyButton({
  variantId,
  ...props
}: ButtonProps & { variantId: string | undefined }) {
  const { selectedQuantity } = useSunrunShopStore('selectedQuantity');

  const handleClick = async () => {
    if (!variantId) return;

    const { cart } = await addOrUpdateCartItem(null, {
      merchandiseId: variantId,
      quantity: selectedQuantity,
    });

    if (cart?.checkoutUrl) {
      window.location.href = cart.checkoutUrl;
    }
  };

  return (
    <Button
      {...props}
      disabled={!variantId}
      onClick={handleClick}
      size={{ xs: ButtonSize.SM, md: ButtonSize.MD }}
    />
  );
}

export default BuyButton;
